import * as angular from 'angular';

import { RangeChart,RangeChartPaneConfiguration  } from '../../../charting/index';
import { ChartDirectiveBase } from './ChartDirectiveBase';

export interface IrangeChartScope<T, U> extends angular.IScope {
    panes: RangeChartPaneConfiguration<T, U>[];
    data: T[];
    ranges: [number, number][];
    isDisabled: boolean;
    domain: [string, string];
}

export class RangeChartDirective extends ChartDirectiveBase {
    static directiveId = 'wtRangeChart';
    scope = {
        panes: '=',
        data: '=',
        ranges: '=?',
        isDisabled: '=?',
        domain: '=?'
    };

    link($scope: IrangeChartScope<any, any>, element, attrs, controller) {
        const containerName = attrs.id;
        element.attr('id', containerName);
        const chart = new RangeChart(containerName);
        chart.isDisabled(!!$scope.isDisabled);
        $scope.$watch(() => $scope.panes, () => {
            if ($scope.panes) {
                chart.updatePanes($scope.panes);
            }
        });

        $scope.$watch(() => $scope.data, () => {
            if ($scope.data) {
                chart.update($scope.data);
            }
        });

        $scope.$watch(() => $scope.ranges, () => {
            if ($scope.ranges) {
                chart.ranges($scope.ranges);
            }
        });
        $scope.$watch(() => $scope.isDisabled, () => {
            chart.isDisabled($scope.isDisabled);
        });
        $scope.$watch(() => $scope.domain, () => {
            chart.xDomain($scope.domain);
        });
    }
}

    // WideTech.Framework.fmwk
    //     .directive(rangeChartDirective.directiveId, [
    //         () =>
    //             new rangeChartDirective()
    //     ]);